<template>

    <a-spin :spinning="loading">
      <a-form-model
        ref="ruleForm"
        :model="pageData"
        :rules="rules"
        :label-col="{ span: 3 }"
        :wrapper-col="{ span: 14 }"
        labelAlign="left"
        style="margin:12px 70px 0 70px;"
      >
        <a-form-model-item label="复核类型" prop="type">
          <a-radio-group v-model="pageData.type" :disabled="readonly">
            <a-radio
              v-for="item in typeOptions"
              :key="item.value"
              :value="item.value"
              name="roleCode"
              style="margin-right:24px;"
            >
              {{ item.name }}

              <a-tooltip>
                <template slot="title">
                  {{ item.remark }}
                </template>
                <a-icon
                  type="exclamation-circle"
                  style="margin-left:8px;color:#999;"
                />
              </a-tooltip>
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          v-if="pageData.type == '2'"
        >
          <div class="text-color-orange text-tip">
            达到一定金额开立祺信复核方可流转到该级，复核以最后一级操作为准<br />变更复核类型会影响当前数据，请确认无复核数据后再进行操作。
          </div>
          <table class="is-rev-table">
            <thead>
              <tr>
                <th class="width-1">复核员</th>
                <th>祺信开立金额</th>
                <th>
                  <a-button type="link" @click="addLevel" v-if="!readonly"
                    >新增</a-button
                  >
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in levelList" :key="index">
                <td class="width-1">{{ index + 1 }} 级</td>
                <td colspan="2">
                  <div class="spaceLeft">
                    <a-input
                      v-model.number="item.amount"
                      @blur="checkAmount(item.amount, index)"
                      :disabled="index == 0 || readonly"
                      suffix="元"
                      placeholder="请输入金额"
                      type="number"
                      style="width:210px"
                    />
                    <span
                      class="text-color-orange"
                      @click="removeLevel(index)"
                      v-if="index > 1 && !readonly"
                      >删除</span
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
    <!-- <template slot="footer">
      <a-button class="btn-blue-line" @click="close()">关闭</a-button>
      <button-load
        @clickHandle="saveBebore"
        type="primary"
        lable="确定"
        v-if="!readonly"
      />
    </template> -->
</template>

<script>
import { ruleSaveOrUpdate, queryRule } from "@/api/issueReview.js";
export default {
  props:["roleCode"],
  data() {
    return {
      readonly: false,
      modalShow: false,
      loading: false,
      pageData: {
        type: "1"
      },
      rules: {},
      typeOptions: [
        {
          value: "1",
          name: "一般",
          remark: "默认为一级"
        },
        {
          value: "2",
          name: "多级",
          remark:
            "达到一定金额可流转到该级复核，复核以最后一级操作为准，最多支持三级"
        }
      ],
      levelList: []
    };
  },
  methods: {
    open(prop = {}) {
      this.readonly = prop.readonly;
      this.getInfo();
      this.modalShow = true;
    },
    init() {
      this.pageData.type = "1";
      this.levelList = [{ amount: 0 }, { amount: undefined }];
    },
    addLevel() {
      if (this.levelList.length == 3) {
        this.$message.warning("最多只能添加3级哦~");
        return;
      }
      this.levelList.push({
        amount: undefined
      });
    },
    removeLevel(index) {
      this.levelList.splice(index, 1);
    },
    checkAmount(amount, index) {
      if (index > 0 && this.levelList[index - 1].amount >= amount) {
        this.$message.warning("输入金额需大于上一级");
        this.levelList[index].amount = undefined;
      }
    },
    getInfo() {
      this.loading = true;
      queryRule({
        roleCode: this.roleCode,
        cstId: this.$store.getters["home/getUserObj"].cstIds[0]
      })
        .then(res => {
          this.loading = false;
          if (res.data && res.data.length > 1) {
            this.pageData.type = "2";
            this.levelList = res.data || [];
          } else {
            this.init();
          }
        })
        .catch(e => {
          this.loading = false;
        });
    },
    saveBebore(btn) {
      let params = [];

      if (this.pageData.type == "2") {
        let notAmount = false;
        this.levelList.forEach((i, index) => {
          if (!i.amount && index > 0) {
            notAmount = true;
            return;
          }
          params.push({
            roleLevel: index + 1,
            amount: i.amount,
            roleCode: this.roleCode == "MENU0402" ? "ROLE0002" : this.roleCode, //开立复核时传复核员的rolecode，后台逻辑要求
            cstId: this.$store.getters["home/getUserObj"].cstIds[0],
            lastestLevel: index == this.levelList.length - 1 ? 1 : 0
          });
        });
        if (notAmount) {
          this.$message.warn("祺信开立金额不能为空");
          return;
        }
      }
      return {
        type: this.pageData.type,
        params,
      }
    },
    save(params) {
      ruleSaveOrUpdate({
        jsonString: JSON.stringify(params)
      })
        .then(res => {})
        .catch(err => {
          console.log(err);
        });
    }
  },
  created(){
    this.init();
  }
};
</script>
<style scoped lang="less">
.text-tip {
  white-space: nowrap;
  line-height: 22px;
}
.is-rev-table {
  width: 360px;
  .width-1 {
    width: 80px;
  }
  td .text-color-orange {
    cursor: pointer;
    margin-left: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/system/character/issue-review-modal.vue